import React, { useId } from 'react';
import { cn } from '@/utils/сn';
import { radioInputStyles } from './styles';

interface RadioButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  id?: string;
  reverse?: boolean;
  wrapperClassName?: string;
}

export const RadioButton: React.FC<RadioButtonProps> = ({ label, id, checked, disabled, reverse, wrapperClassName, ...props }) => {
  const generatedId = useId();
  const inputId = id || `radio-${generatedId}`;

  return (
    <div className={cn('flex items-center gap-3', reverse && 'flex-row-reverse', wrapperClassName)}>
      <input
        type="radio"
        id={inputId}
        className={radioInputStyles({ checked, disabled })}
        checked={checked}
        disabled={disabled}
        {...props}
      />
      {label && (
        <label htmlFor={inputId} className="text-body-regular text-black cursor-pointer">
          {label}
        </label>
      )}
    </div>
  );
};

export default RadioButton;
